module.exports = __webpack_public_path__ + "img/pay-box-inactive.e511fbbb.svg";